// =============================================
// GROUTH - Mock Data for Frontend
// =============================================

export const BRAND = {
  name: 'grouth',
  tagline: 'Fast growth for ambitious brands.',
  logoFull: '/brand/grouth-logo.png',
  favicon: '/brand/grouth-favicon.jpg',
  colors: {
    charcoal: '#242326',
    growthGreen: '#83BF42',
    offWhite: '#FDFEFA',
    lightCharcoal: '#4A4A48',
    accentGreen: '#A8D96C',
    neutralGray: '#B8B8B8',
  },
};

export const NAV_LINKS = [
  { label: 'Services', href: '#services', hasDropdown: true },
  { label: 'Work', href: '/work', isRoute: true },
  { label: 'About', href: '#about' },
  { label: 'Insights', href: '/insights', isRoute: true },
];

export const HERO_CONTENT = {
  headline: 'We partner ambitious brands for fast growth.',
  subline: 'Truly effective growth marketing.',
  cta: { label: 'Get Started', href: '#contact' },
};

export const ABOUT_CONTENT = {
  headline: 'Years of driving sustainable growth for ambitious brands',
  description: 'We help brands with high-growth aspirations capture market attention. Our approach is simple: we delve deep into your customers\' world, use data-driven insights, leverage the latest tech, and deploy best-in-class talent to tackle the challenges that truly matter to you.',
  cta: { label: 'Get in touch', href: '#contact' },
};

export const CLIENTS = [
  'Samsung',
  'Netflix',
  'BetKing',
  'Nokia',
  'Golden Penny',
  'VBank',
  'Credit Direct',
  'Onboard Wallet',
  'MedPlus',
  'Medicentre',
  'CANDO!',
  'Bokku Mart',
  'SPAR',
];

export const CASE_STUDIES = [
  {
    id: 'cs-pesa',
    title: 'Scaling user acquisition for a global remittance platform',
    client: 'Pesa',
    industry: 'Fintech',
    category: 'Paid Media',
    heroImage: '/generated/hero_pesa.png',
    dashboardImage: '/cases/slide3_img4.png',
    dashboardImage2: '/cases/slide3_img5.png',
    statHighlight: '50,000+',
    statLabel: 'new registrations achieved during the campaign',
    stats: [
      { value: '50K+', label: 'new users acquired' },
      { value: '22%', label: 'increase in active users' },
    ],
    description: 'Increased active users by 22% in 6 months. Acquired over 50,000 users in 7 months through targeted Meta Ads campaigns and Grafana-driven analytics.',
    whatWasDone: 'Increased active users by 22% in 6 months. Acquired over 50,000 users in 7 months through precision-targeted paid media across Meta platforms, with real-time performance monitoring via Grafana analytics dashboards.',
    platform: 'Meta Ads & Grafana Analytics',
  },
  {
    id: 'cs-vbank',
    title: 'Delivering half a million downloads for a digital bank',
    client: 'VBank',
    industry: 'Fintech',
    category: 'App Marketing',
    heroImage: '/generated/hero_vbank.png',
    dashboardImage: '/cases/slide7_img14.png',
    statHighlight: '200,000+',
    statLabel: 'new registrations achieved during the campaign',
    stats: [
      { value: '200K+', label: 'registered users' },
      { value: '500K+', label: 'app downloads' },
    ],
    description: 'Delivered over 500,000 downloads and 200,000 registered users with a highly efficient average cost per acquisition of ₦814.',
    whatWasDone: 'Delivered over 500,000 downloads and 200,000 registered users with a highly efficient average cost per acquisition of ₦814. Campaign tracked and optimised via AppsFlyer attribution dashboards.',
    platform: 'AppsFlyer Dashboard',
  },
  {
    id: 'cs-onboard',
    title: 'Onboarding merchants and users at scale for a digital wallet',
    client: 'Onboard Wallet',
    industry: 'Retail / Fintech',
    category: 'Paid Media',
    heroImage: '/generated/hero_onboard.png',
    dashboardImage: '/cases/slide6_img11.png',
    dashboardImage2: '/cases/slide6_img12.png',
    statHighlight: '14,000+',
    statLabel: 'new registrations achieved during the campaign',
    stats: [
      { value: '14K+', label: 'new user registrations' },
      { value: '42%', label: 'CPA reduction in 6 months' },
    ],
    description: 'Onboarded over 2,000 merchants using paid media (Meta & Google). Acquired over 14,000 new users with 11% activation rate. Reduced CPA from $1.33 to $0.77.',
    whatWasDone: 'Onboarded over 2,000 merchants using paid media (Meta & Google). Acquired over 14,000 new users with an activation rate of 11%. Reduced CPA from $1.33 to $0.77 in 6 months and CAC from $28 to $13.',
    platform: 'Meta Ads Dashboard',
  },
  {
    id: 'cs-netflix',
    title: 'Driving cultural buzz for a flagship title launch',
    client: 'Netflix',
    industry: 'Entertainment',
    category: 'Brand Launch',
    heroImage: '/generated/hero_netflix.png',
    dashboardImage: '/generated/banner_netflix_banner.png',
    statHighlight: 'Cultural Talkability',
    statLabel: 'driving successful title launch and significant mobile plan sign-ups',
    stats: [
      { value: 'Viral', label: 'cultural talkability' },
      { value: '₦1,200', label: 'mobile plan sign-ups driven' },
    ],
    description: 'Executed a high-visibility teaser phase and strategic site takeovers to coincide the King of Boys 2 launch with the 1,200 naira mobile plan introduction.',
    whatWasDone: 'Executed a high-visibility teaser phase and strategic site takeovers to coincide the \"King of Boys 2\" launch with the ₦1,200 mobile plan introduction, generating massive cultural talkability across Nigeria.',
    platform: 'Digital & Site Takeovers',
  },
  {
    id: 'cs-betking',
    title: 'Rebranding a leading sports betting platform across digital',
    client: 'BetKing',
    industry: 'Gaming',
    category: 'Brand Relaunch',
    heroImage: '/generated/hero_betking.png',
    dashboardImage: '/generated/banner_betking_banner.png',
    statHighlight: '10,000+',
    statLabel: 'new registrations achieved during the campaign sustenance phase',
    stats: [
      { value: '10K+', label: 'new registrations' },
      { value: '360°', label: 'digital rebrand execution' },
    ],
    description: 'Delivered a comprehensive rebranding campaign on all digital platforms, centered on the new tagline \"That feeling, that\'s BetKing\".',
    whatWasDone: 'Delivered a comprehensive rebranding campaign on all digital platforms, centered on the new tagline \"That feeling, that\'s BetKing\". Achieved 10,000+ new registrations during the campaign sustenance phase.',
    platform: 'All Digital Platforms',
  },
  {
    id: 'cs-nokia',
    title: 'Positioning a flagship phone via a James Bond partnership',
    client: 'Nokia',
    industry: 'Electronics',
    category: 'Product Launch',
    heroImage: '/generated/hero_nokia.png',
    dashboardImage: '/generated/banner_nokia_banner.png',
    statHighlight: '3,000+',
    statLabel: 'units sold on Jumia within the first month of the movie debut',
    stats: [
      { value: '3K+', label: 'units sold in first month' },
      { value: 'James Bond', label: 'partnership activated' },
    ],
    description: 'Positioned the Nokia 8.3 Series as the \"phone for adventurers\" via a strategic James Bond movie partnership and Jumia e-commerce execution.',
    whatWasDone: 'Positioned the Nokia 8.3 Series as the \"phone for adventurers\" via a strategic James Bond movie partnership and Jumia e-commerce execution, driving 3,000+ units sold within the first month.',
    platform: 'Jumia & Digital',
  },
  {
    id: 'cs-spar',
    title: 'Surpassing sales targets through digital foot traffic campaigns',
    client: 'SPAR',
    industry: 'Retail',
    category: 'Paid Media',
    heroImage: '/generated/hero_spar.png',
    dashboardImage: '/generated/banner_spar_banner.png',
    statHighlight: '₦2B+',
    statLabel: 'sales target surpassed, with significant increases in foot traffic and basket value',
    stats: [
      { value: '₦2B+', label: 'sales target surpassed' },
      { value: 'Geo-targeted', label: 'map extensions deployed' },
    ],
    description: 'Executed a digital-heavy strategy featuring price reveal teases and geo-targeted map extensions to drive store foot traffic.',
    whatWasDone: 'Executed a digital-heavy strategy featuring price reveal teases and geo-targeted map extensions to drive store foot traffic, surpassing the ₦2 billion sales target with significant increases in basket value.',
    platform: 'Google & Social',
  },
  {
    id: 'cs-pif',
    title: 'Scaling a social commerce platform through events and digital',
    client: 'Pay It Forward (PIF)',
    industry: 'Social Commerce',
    category: 'Growth Strategy',
    heroImage: '/generated/hero_pif.png',
    dashboardImage: '/cases/slide9_img18.png',
    dashboardImage2: '/cases/slide9_img19.png',
    statHighlight: '17,000+',
    statLabel: 'new users and 3,000+ new vendors',
    stats: [
      { value: '17K+', label: 'new users acquired' },
      { value: '3K+', label: 'new vendors onboarded' },
    ],
    description: 'Leveraged a mix of strategic partnerships, live events, and targeted digital campaigns to achieve significant scale with high capital efficiency.',
    whatWasDone: 'Leveraged a mix of strategic partnerships, live events, and targeted digital campaigns to achieve significant scale with high capital efficiency, acquiring 17,000+ new users and 3,000+ new vendors.',
    platform: 'Partnerships & Digital',
  },
  {
    id: 'cs-medicentre',
    title: 'Driving clinical bookings through precision paid media',
    client: 'Medicentre',
    industry: 'Healthcare',
    category: 'Paid Media',
    heroImage: '/generated/hero_medicentre.png',
    dashboardImage: '/cases/slide10_img21.png',
    dashboardImage2: '/cases/slide10_img22.png',
    statHighlight: '178 Bookings',
    statLabel: 'achieved alongside 175 social leads generated within just 2 months',
    stats: [
      { value: '178', label: 'clinical bookings driven' },
      { value: '175', label: 'social leads in 2 months' },
    ],
    description: 'Utilized precision Search and social media ads to identify and target high-intent users for clinical screening and doctor sessions.',
    whatWasDone: 'Utilized precision Search and social media ads to identify and target high-intent users for clinical screening and doctor sessions, achieving 178 bookings alongside 175 social leads generated within just 2 months.',
    platform: 'Google Analytics & Meta Ads',
  },
  {
    id: 'cs-toriara',
    title: 'Achieving 5x ROAS on a sales promo campaign',
    client: 'Toriara Naturals',
    industry: 'Beauty / FMCG',
    category: 'E-Commerce',
    heroImage: '/generated/hero_toriara.png',
    dashboardImage: '/cases/slide8_img16.png',
    statHighlight: '₦4.3M+',
    statLabel: 'recorded ₦4.3M naira sales on a ₦800K budget',
    stats: [
      { value: '₦4.3M', label: 'in net sales' },
      { value: '5.4x', label: 'return on ad spend' },
    ],
    description: 'Launched a sales promo campaign with a budget of ₦800K and achieved over ₦4.3M in net sales.',
    whatWasDone: 'Launched a targeted sales promo campaign with a budget of ₦800K and achieved over ₦4.3M in net sales, delivering a 5.4x return on ad spend through the Shopify-integrated e-commerce funnel.',
    platform: 'Shopify Dashboard',
  },
  {
    id: 'cs-cando',
    title: 'Building a youth community through music-driven influencer strategy',
    client: 'CANDO!',
    industry: 'Digital Services',
    category: 'Brand Building',
    heroImage: '/generated/hero_cando.png',
    dashboardImage: '/cases/slide14_img28.png',
    dashboardImage2: '/cases/slide14_img29.png',
    statHighlight: '34,000+',
    statLabel: 'highly engaged fans, with over 10,000 new social media followers',
    stats: [
      { value: '34K+', label: 'engaged fans reached' },
      { value: '10K+', label: 'new social followers' },
    ],
    description: 'Developed a promo website and a music-driven influencer strategy to connect with millennials and drive brand preference.',
    whatWasDone: 'Developed a promo website and a music-driven influencer strategy to connect with millennials and drive brand preference, reaching 34,000+ highly engaged fans with over 10,000 new social media followers.',
    platform: 'Social & Influencer',
  },
  {
    id: 'cs-stem',
    title: 'Driving 1,000+ sign-ups for a kids education programme',
    client: 'Stem Africa',
    industry: 'Education',
    category: 'Lead Generation',
    heroImage: '/generated/hero_stem.png',
    dashboardImage: '/cases/slide4_img7.png',
    statHighlight: '1,000+',
    statLabel: 'sign-ups driving successful registrations for the 1-week programme',
    stats: [
      { value: '1K+', label: 'sign-ups in 30 days' },
      { value: '30 days', label: 'campaign duration' },
    ],
    description: 'Drove sign-ups for the Stem Africa kids programme which saw over 1,000 sign-ups within 30 days through Meta Ads.',
    whatWasDone: 'Drove sign-ups for the Stem Africa kids programme which saw over 1,000 sign-ups within 30 days through targeted Meta Ads campaigns optimized for conversion.',
    platform: 'Meta Ads Dashboard',
  },
  {
    id: 'cs-assessify',
    title: 'Driving purchases for a banking career test platform',
    client: 'Test Assessify',
    industry: 'Education / Career',
    category: 'E-Commerce',
    heroImage: '/generated/hero_assessify.png',
    dashboardImage: '/cases/slide5_img9.png',
    statHighlight: '400+',
    statLabel: 'driving successful purchases of the test assessify test bundles',
    stats: [
      { value: '400+', label: 'test bundle purchases' },
      { value: 'Meta Ads', label: 'primary acquisition channel' },
    ],
    description: 'Drove purchases for the Test Assessify programme designed to equip those looking to land banking roles with skills needed to pass assessments.',
    whatWasDone: 'Drove purchases for the Test Assessify programme. The test was designed to equip those looking to land banking roles with skills needed to pass banking assessments, achieving 400+ purchases through Meta Ads.',
    platform: 'Meta Ads Dashboard',
  },
];

export const PARTNERS = [
  'Google Ads',
  'Meta',
  'TikTok',
  'Shopify',
  'AppsFlyer',
  'BigQuery',
  'Grafana',
  'Jumia',
  'Programmatic',
];

export const TESTIMONIALS = [
  {
    quote: 'Grouth has been helping us expand our brand reach in the Nigerian market by planning and executing successful crypto acquisition campaigns with their data-driven approach. We cannot recommend them enough!',
    name: 'David Alao',
    role: 'Marketing Lead',
    company: 'Kingcards',
  },
  {
    quote: "We've tried several performance agencies but got good value for our trading product, with Grouth. Beyond the campaign delivery, they're very professional and are a bank of insights for my team!",
    name: 'Daniel Eka',
    role: 'CMO',
    company: 'Trader Zone',
  },
  {
    quote: 'Our category is quite sensitive, but they used a range of digital campaigns and drove our costs to the lowest we\'ve seen in years. It\'s been a great opportunity to work with their team!',
    name: 'Ademola Farouk',
    role: 'Marketing Consultant',
    company: 'Oxford HealthPlus Hospitals',
  },
];

export const SERVICES = [
  {
    title: 'Brand Strategy',
    description: 'Unlock your brand\'s growth potential with strategy that differentiates your offering and matches your ambition.',
    icon: 'target',
  },
  {
    title: 'Media Planning & Buying',
    description: 'Plan and execute efficient cross-channel media buys: from OOH to web and mobile. If it\'s not measurable, we don\'t do it.',
    icon: 'bar-chart',
  },
  {
    title: 'Adtech Consultancy',
    description: 'The right platforms and training you need. From programmatic buying to complex integrations and cookieless advertising.',
    icon: 'settings',
  },
  {
    title: 'Creative Production',
    description: 'Connect with your audience on a deeper level with insights-driven creative development and formats that resonate.',
    icon: 'palette',
  },
  {
    title: 'Market Insights',
    description: 'Make the best strategic decisions with data-based insights. Tailored research solutions for your brand and customers.',
    icon: 'search',
  },
  {
    title: 'Programmatic Yield',
    description: 'From setup to deployment, optimisation and attribution. Be it DCO, In-Game Advertising, or CRM/CDP setups.',
    icon: 'trending-up',
  },
];

export const CONTACT_INFO = {
  email: 'daniel@grouth.co',
  offices: [
    {
      city: 'Lagos',
      address: 'Lekki Phase I, Lagos, Nigeria',
      phone: '+234 (0) 8117398259',
      tel: 'tel:+2348117398259',
    },
    {
      city: 'Calgary',
      address: '38 Belmont Row SW, Calgary, AB',
      phone: '+1 587-585-1161',
      tel: 'tel:+15875851161',
    },
  ],
  // Legacy top-level fields — kept so any consumer still reading
  // CONTACT_INFO.office / .address / .phone gets the primary (registered)
  // office. New surfaces should iterate `offices` instead.
  office: 'Lagos',
  address: 'Lekki Phase I, Lagos, Nigeria',
  phone: '+234 (0) 8117398259',
};

export const MARQUEE_WORDS = [
  "Let's chat",
  'Hablemos',
  'Parliamo',
  'Vamos Conversar',
  'Discutons',
  "Lass uns reden",
  "Let's chat",
  'Hablemos',
  'Parliamo',
  'Vamos Conversar',
  'Discutons',
  "Lass uns reden",
];
